import initialState from './initialState';

export default function routesPermissions(state = initialState.auth, action) {
  switch (action.type) {
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/routesPermissionsReducer.js